import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import { UseLanguageReturn } from '../types/i18n';

export const useLanguage = (): UseLanguageReturn => {
    const { i18n, t } = useTranslation();
    const initialized = useRef(false);

    const applyDirection = (lng: string) => {
        document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = lng;
    };

    const changeLanguage = (lng: string) => {
        localStorage.setItem('preferredLanguage', lng);
        i18n.changeLanguage(lng);
        applyDirection(lng);
    };

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;

            const savedLang = localStorage.getItem('preferredLanguage');
            const browserLang = navigator.language?.split('-')[0] || 'en';

            // PRIORITÉ :
            // 1️⃣ langue sauvegardée par l'utilisateur
            // 2️⃣ sinon langue du navigateur
            const langToUse = savedLang || browserLang;

            changeLanguage(langToUse);
        }
    }, []);

    return {
        currentLanguage: i18n.language,
        changeLanguage,
        t,
        isRTL: i18n.language === 'ar',
    };
};